import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '@core/services/data.service';
import { Codebook } from '@shared/models/codebooks/codebook';

@Component({
    selector: 'app-payment-frequency',
    templateUrl: './payment-frequency.component.html',
    styleUrls: ['./payment-frequency.component.scss'],
    standalone: false
})
export class PaymentFrequencyComponent implements OnInit {
  @Input() paymentFrequencyId: number;

  private paymentFrequencyList: Codebook[];
  public paymentFrequency: string;

  constructor(
      private dataService: DataService) {
  }

  ngOnInit(): void {
    this.paymentFrequency = this.dataService.codebooks.paymentFrequency.findById(this.paymentFrequencyId).textToTranslate;
  }

}
